import { Reason, SubReason } from '@/modules/attendance/entities/reasons/reasons.interfaces';
import { SubReasonName, AttendanceReasonVisibilityGroup } from '@/modules/attendance/entities/reasons/reasons.enums';

export const subReasonByName: Record<SubReasonName, SubReason> = {
  ABERTURA_DE_PLANO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Abertura de plano',
    'value': 'Abertura de plano',
  },
  ABERTURA_DE_SUBFATURA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Abertura de Subfatura',
    'value': 'Abertura de Subfatura',
  },
  ACERTO_DE_IMPLANTACAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Acerto de implantação',
    'value': 'Acerto de implantação',
  },
  ACESSO_AO_APLICATIVO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Acesso ao aplicativo',
    'value': 'Acesso ao aplicativo',
  },
  ADITIVOS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Aditivos',
    'value': 'Aditivos',
  },
  AJUSTES: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Ajustes',
    'value': 'Ajustes',
  },
  ALTERACAO_CADASTRAL: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Alteração Cadastral',
    'value': 'Alteração Cadastral',
  },
  ALTERACAO_SENHA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Alteração senha',
    'value': 'Alteração senha',
  },
  ANALISE_ISENCAO_DE_CARENCIA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Análise isenção de carência',
    'value': 'Análise isenção de carência',
  },
  ANTECIPACAO_DE_FATURA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Antecipação de fatura',
    'value': 'Antecipação de fatura',
  },
  APLICATIVO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Aplicativo',
    'value': 'Aplicativo',
  },
  ARQUIVO_DE_CONTABILIZACAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Arquivo de contabilização',
    'value': 'Arquivo de contabilização',
  },
  ARQUIVO_DE_RATEIO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Arquivo de rateio',
    'value': 'Arquivo de rateio',
  },
  ATUALIZACAO_DE_INFORMACOES: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Atualização de informações',
    'value': 'Atualização de informações',
  },
  AUXILIO_NO_LOGIN: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Auxilio no login',
    'value': 'Auxilio no login',
  },
  BASE_DE_ATIVOS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Base de ativos',
    'value': 'Base de ativos',
  },
  BASE_DE_VIDAS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Base de vidas',
    'value': 'Base de vidas',
  },
  BLOQUEIO_DE_ACESSO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Bloqueio de acesso',
    'value': 'Bloqueio de acesso',
  },
  CAMPANHA_DE_ADESAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Campanha de adesão',
    'value': 'Campanha de adesão',
  },
  CANCELAMENTO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Cancelamento',
    'value': 'Cancelamento',
  },
  CANCELAMENTO_DE_CONTRATO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Cancelamento de contrato',
    'value': 'Cancelamento de contrato',
  },
  CANCELAMENTO_DE_ESTIPULANTE: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Cancelamento de estipulante',
    'value': 'Cancelamento de estipulante',
  },
  CANCELAMENTO_DE_MOVIMENTACAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Cancelamento de movimentação',
    'value': 'Cancelamento de movimentação',
  },
  CANCELAMENTO_DE_SUBESTIPULANTE: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Cancelamento de subestipulante',
    'value': 'Cancelamento de subestipulante',
  },
  CANCELAMENTO_POR_INADIMPLENCIA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Cancelamento por inadimplência',
    'value': 'Cancelamento por inadimplência',
  },
  CARENCIA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Carência',
    'value': 'Carência',
  },
  CARTA_DE_PERMANENCIA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Carta de Permanência',
    'value': 'Carta de Permanência',
  },
  CARTOES_INFORMACAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Cartões - Informação',
    'value': 'Cartões - Informação',
  },
  CARTOES_RENOVACAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Cartões - Renovação',
    'value': 'Cartões - Renovação',
  },
  CASHBACK_QUESTIONAMENTO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Cashback - Questionamento',
    'value': 'Cashback - Questionamento',
  },
  COBERTURA_ANS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Cobertura ANS',
    'value': 'Cobertura ANS',
  },
  COMITE_DE_SAUDE: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Comitê de Saúde',
    'value': 'Comitê de Saúde',
  },
  COMITE_OPERACIONAL: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Comitê Operacional',
    'value': 'Comitê Operacional',
  },
  COMUNICACAO_MAIORIDADE: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Comunicação maioridade',
    'value': 'Comunicação maioridade',
  },
  COMUNICADO_DE_SINISTRO_PARA_SEGURADORA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Comunicado de sinistro para seguradora',
    'value': 'Comunicado de sinistro para seguradora',
  },
  CONTA_MEDICA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Conta médica',
    'value': 'Conta médica',
  },
  CONTATO_EQUIPE_INTERNA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Contato equipe interna',
    'value': 'Contato equipe interna',
  },
  CONTATO_OPERADORA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Contato operadora',
    'value': 'Contato operadora',
  },
  CONTROLE_E_ENVIO_DE_CARTOES: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Controle e envio de cartões',
    'value': 'Controle e envio de cartões',
  },
  CONVERSAO_DE_ARQUIVOS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Conversão de arquivos',
    'value': 'Conversão de arquivos',
  },
  COPAY: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Copay',
    'value': 'Copay',
  },
  CRIACAO_DE_USUARIO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Criação de usuário',
    'value': 'Criação de usuário',
  },
  DESBLOQUEIO_DE_USUARIO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Desbloqueio de usuário',
    'value': 'Desbloqueio de usuário',
  },
  DOCUMENTACAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Documentação',
    'value': 'Documentação',
  },
  DUVIDA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Dúvida',
    'value': 'Dúvida',
  },
  DUVIDA_DE_COBERTURA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Dúvida de cobertura',
    'value': 'Dúvida de cobertura',
  },
  DUVIDA_DESCREDENCIAMENTO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Dúvida - Descredenciamento',
    'value': 'Dúvida - Descredenciamento',
  },
  DUVIDA_MAIORIDADE: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Dúvida maioridade',
    'value': 'Dúvida maioridade',
  },
  DUVIDA_REMISSAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Dúvida remissão',
    'value': 'Dúvida remissão',
  },
  DUVIDAS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Dúvidas',
    'value': 'Dúvidas',
  },
  DUVIDAS_CONTRATUAIS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Dúvidas contratuais',
    'value': 'Dúvidas contratuais',
  },
  DUVIDAS_DE_FATURAMENTO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Dúvidas de faturamento',
    'value': 'Dúvidas de faturamento',
  },
  DUVIDA_SUBSIDIO_DE_MEDICAMENTOS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Dúvida Subsídio de Medicamentos',
    'value': 'Dúvida Subsídio de Medicamentos',
  },
  EMISSAO_DE_VOUCHER: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Emissão de Voucher',
    'value': 'Emissão de Voucher',
  },
  ENVIO_CERTIFICADO_SEGURO_VIDA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Envio certificado Seguro Vida',
    'value': 'Envio certificado Seguro Vida',
  },
  ENVIO_DE_COMUNICADOS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Envio de comunicados',
    'value': 'Envio de comunicados',
  },
  ENVIO_DE_FATURAMENTO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Envio de Faturamento',
    'value': 'Envio de Faturamento',
  },
  ENVIO_DE_FATURAMENTO_AO_CLIENTE: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Envio de faturamento ao cliente',
    'value': 'Envio de faturamento ao cliente',
  },
  EXCLUSAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Exclusão',
    'value': 'Exclusão',
  },
  EXTENSAO_DE_BENEFICIO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Extensão de benefício',
    'value': 'Extensão de benefício',
  },
  EXTRATO_DE_COPARTICIPACAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Extrato de coparticipação',
    'value': 'Extrato de coparticipação',
  },
  FATURA_TECNICA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Fatura tecnica',
    'value': 'Fatura tecnica',
  },
  GYMPASS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Gympass',
    'value': 'Gympass',
  },
  IMPORTACAO_BASE_SEGURO_VIDA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Importação Base Seguro Vida',
    'value': 'Importação Base Seguro Vida',
  },
  INCLUSAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Inclusão',
    'value': 'Inclusão',
  },
  INCLUSAO_DE_DEMITIDOS_APOSENTADOS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Inclusão de demitidos/aposentados',
    'value': 'Inclusão de demitidos/aposentados',
  },
  INCLUSAO_DE_REMIDOS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Inclusão de remidos',
    'value': 'Inclusão de remidos',
  },
  INCLUSAO_FORA_DO_PRAZO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Inclusão fora do prazo',
    'value': 'Inclusão fora do prazo',
  },
  INDICACAO_DE_CREDENCIAMENTO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Indicação de credenciamento',
    'value': 'Indicação de credenciamento',
  },
  INFORMACAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Informação',
    'value': 'Informação',
  },
  INFORMACOES: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Informações',
    'value': 'Informações',
  },
  INFORMACOES_DE_REEMBOLSO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Informações de reembolso',
    'value': 'Informações de reembolso',
  },
  INFORME_RENDIMENTO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Informe Rendimento',
    'value': 'Informe Rendimento',
  },
  LIBERACAO_STATUS_DE_SENHA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Liberação/status de senha',
    'value': 'Liberação/status de senha',
  },
  LIBERACAO_DE_PROCEDIMENTO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Liberação de Procedimento',
    'value': 'Liberação de Procedimento',
  },
  LIMINAR: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Liminar',
    'value': 'Liminar',
  },
  MATERIAL_INFORMATIVO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Material Informativo',
    'value': 'Material Informativo',
  },
  NAO_RECEBIMENTO_DO_CARTAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Não recebimento do cartão',
    'value': 'Não recebimento do cartão',
  },
  NEGATIVA_DE_PROCEDIMENTO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Negativa de Procedimento',
    'value': 'Negativa de Procedimento',
  },
  NEGATIVA_DE_USO_MEDICAMENTO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Negativa de uso Medicamento',
    'value': 'Negativa de uso Medicamento',
  },
  NUMERACAO_DE_CARTAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Numeração de Cartão',
    'value': 'Numeração de Cartão',
  },
  NUMERO_DA_CARTEIRINHA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Número da Carteirinha',
    'value': 'Número da Carteirinha',
  },
  ORIENTACOES_SOBRE_LIBERACAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Orientações sobre liberação',
    'value': 'Orientações sobre liberação',
  },
  OUTRO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Outro',
    'value': 'Outro',
  },
  PEDIDO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Pedido',
    'value': 'Pedido',
  },
  PREVIA_DE_REEMBOLSO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Previa de reembolso',
    'value': 'Previa de reembolso',
  },
  PROPOSTA_DE_ADESAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Proposta de adesão',
    'value': 'Proposta de adesão',
  },
  PRORROGACAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Prorrogação',
    'value': 'Prorrogação',
  },
  QV_ACOES_DE_SAUDE: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'QV - Ações de saúde',
    'value': 'QV - Ações de saúde',
  },
  REAJUSTE: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Reajuste',
    'value': 'Reajuste',
  },
  REATIVACAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Reativação',
    'value': 'Reativação',
  },
  REATIVACAO_APOLICE: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Reativação Apólice',
    'value': 'Reativação Apólice',
  },
  REDE_CREDENCIADA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Rede Credenciada',
    'value': 'Rede Credenciada',
  },
  REEMBOLSO_REANALISE: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Reembolso reanalise',
    'value': 'Reembolso reanalise',
  },
  REFATURAMENTO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Refaturamento',
    'value': 'Refaturamento',
  },
  RELATORIOS_GERENCIAIS: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Relatórios gerenciais',
    'value': 'Relatórios gerenciais',
  },
  REMISSAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Remissão',
    'value': 'Remissão',
  },
  SEGUNDA_VIA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Segunda via',
    'value': 'Segunda via',
  },
  SEGURO_DE_VIDA: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Seguro de Vida',
    'value': 'Seguro de Vida',
  },
  SOLICITACAO_DE_2_VIA_DE_CARTAO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Solicitação de 2ª via de cartão',
    'value': 'Solicitação de 2ª via de cartão',
  },
  SOLICITAR_REEMBOLSO: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Solicitar reembolso',
    'value': 'Solicitar reembolso',
  },
  UPGRADE: {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Upgrade',
    'value': 'Upgrade',
  },
};

export const reasons: Reason[] = [
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Análise de Documentos',
    'value': 'Análise de Documentos',
    'subReasons': [
      subReasonByName.COMUNICADO_DE_SINISTRO_PARA_SEGURADORA,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Assistência viagem',
    'value': 'Assistência viagem',
    'subReasons': [
      subReasonByName.EMISSAO_DE_VOUCHER,
      subReasonByName.INFORMACOES,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Autorizações',
    'value': 'Autorizações',
    'subReasons': [
      subReasonByName.LIBERACAO_DE_PROCEDIMENTO,
      subReasonByName.NEGATIVA_DE_PROCEDIMENTO,
      subReasonByName.ORIENTACOES_SOBRE_LIBERACAO,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Bate cadastral',
    'value': 'Bate cadastral',
    'subReasons': [
      subReasonByName.AJUSTES,
      subReasonByName.DUVIDAS,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Benefícios Não Seguráveis',
    'value': 'Benefícios Não Seguráveis',
    'subReasons': [
      subReasonByName.ALTERACAO_CADASTRAL,
      subReasonByName.CONTROLE_E_ENVIO_DE_CARTOES,
      subReasonByName.INFORMACAO,
      subReasonByName.PEDIDO,
      subReasonByName.SEGUNDA_VIA,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Chat',
    'value': 'Chat',
    'subReasons': [
      subReasonByName.CANCELAMENTO_DE_CONTRATO,
      subReasonByName.CRIACAO_DE_USUARIO,
      subReasonByName.DUVIDAS_CONTRATUAIS,
      subReasonByName.DUVIDAS_DE_FATURAMENTO,
      subReasonByName.ENVIO_DE_FATURAMENTO,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Contrato',
    'value': 'Contrato',
    'subReasons': [
      subReasonByName.ABERTURA_DE_PLANO,
      subReasonByName.ABERTURA_DE_SUBFATURA,
      subReasonByName.ADITIVOS,
      subReasonByName.CAMPANHA_DE_ADESAO,
      subReasonByName.CANCELAMENTO_DE_ESTIPULANTE,
      subReasonByName.CANCELAMENTO_DE_SUBESTIPULANTE,
      subReasonByName.CANCELAMENTO_POR_INADIMPLENCIA,
      subReasonByName.DUVIDA_DE_COBERTURA,
      subReasonByName.LIMINAR,
      subReasonByName.REATIVACAO_APOLICE,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Coparticipação',
    'value': 'Coparticipação',
    'subReasons': [
      subReasonByName.CONVERSAO_DE_ARQUIVOS,
      subReasonByName.EXTRATO_DE_COPARTICIPACAO,
      subReasonByName.INFORMACOES,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Dúvidas',
    'value': 'Dúvidas',
    'subReasons': [
      subReasonByName.ABERTURA_DE_SUBFATURA,
      subReasonByName.ALTERACAO_CADASTRAL,
      subReasonByName.ALTERACAO_SENHA,
      subReasonByName.ANALISE_ISENCAO_DE_CARENCIA,
      subReasonByName.APLICATIVO,
      subReasonByName.BASE_DE_ATIVOS,
      subReasonByName.CANCELAMENTO_DE_MOVIMENTACAO,
      subReasonByName.CARENCIA,
      subReasonByName.CARTA_DE_PERMANENCIA,
      subReasonByName.CARTOES_INFORMACAO,
      subReasonByName.CARTOES_RENOVACAO,
      subReasonByName.COBERTURA_ANS,
      subReasonByName.CONTA_MEDICA,
      subReasonByName.DUVIDA_REMISSAO,
      subReasonByName.ENVIO_DE_COMUNICADOS,
      subReasonByName.EXCLUSAO,
      subReasonByName.EXTENSAO_DE_BENEFICIO,
      subReasonByName.GYMPASS,
      subReasonByName.INCLUSAO,
      subReasonByName.INFORME_RENDIMENTO,
      subReasonByName.LIBERACAO_STATUS_DE_SENHA,
      subReasonByName.NAO_RECEBIMENTO_DO_CARTAO,
      subReasonByName.NUMERACAO_DE_CARTAO,
      subReasonByName.NUMERO_DA_CARTEIRINHA,
      subReasonByName.OUTRO,
      subReasonByName.REAJUSTE,
      subReasonByName.REATIVACAO,
      subReasonByName.REMISSAO,
      subReasonByName.SEGURO_DE_VIDA,
      subReasonByName.SOLICITACAO_DE_2_VIA_DE_CARTAO,
      subReasonByName.UPGRADE,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Faturamento',
    'value': 'Faturamento',
    'subReasons': [
      subReasonByName.ANTECIPACAO_DE_FATURA,
      subReasonByName.ARQUIVO_DE_CONTABILIZACAO,
      subReasonByName.ARQUIVO_DE_RATEIO,
      subReasonByName.BASE_DE_VIDAS,
      subReasonByName.CASHBACK_QUESTIONAMENTO,
      subReasonByName.COPAY,
      subReasonByName.ENVIO_DE_FATURAMENTO_AO_CLIENTE,
      subReasonByName.FATURA_TECNICA,
      subReasonByName.INFORMACOES,
      subReasonByName.PRORROGACAO,
      subReasonByName.REFATURAMENTO,
      subReasonByName.SEGUNDA_VIA,
      subReasonByName.OUTRO,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Hospital Digital',
    'value': 'Hospital Digital',
    'subReasons': [
      subReasonByName.ACESSO_AO_APLICATIVO,
      subReasonByName.DUVIDAS,
      subReasonByName.DUVIDA_SUBSIDIO_DE_MEDICAMENTOS,
      subReasonByName.NEGATIVA_DE_USO_MEDICAMENTO,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Implantação',
    'value': 'Implantação',
    'subReasons': [
      subReasonByName.ACERTO_DE_IMPLANTACAO,
      subReasonByName.CONTATO_EQUIPE_INTERNA,
      subReasonByName.CONTATO_OPERADORA,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Maioridade',
    'value': 'Maioridade',
    'subReasons': [
      subReasonByName.COMUNICACAO_MAIORIDADE,
      subReasonByName.DUVIDA_MAIORIDADE,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Movimentação cadastral',
    'value': 'Movimentação cadastral',
    'subReasons': [
      subReasonByName.ALTERACAO_CADASTRAL,
      subReasonByName.ALTERACAO_SENHA,
      subReasonByName.ANALISE_ISENCAO_DE_CARENCIA,
      subReasonByName.CANCELAMENTO,
      subReasonByName.CARTA_DE_PERMANENCIA,
      subReasonByName.INCLUSAO,
      subReasonByName.INCLUSAO_DE_DEMITIDOS_APOSENTADOS,
      subReasonByName.INCLUSAO_DE_REMIDOS,
      subReasonByName.INCLUSAO_FORA_DO_PRAZO,
      subReasonByName.INFORMACOES,
      subReasonByName.PROPOSTA_DE_ADESAO,
      subReasonByName.REATIVACAO,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Outros',
    'value': 'Outros',
    'subReasons': [
      subReasonByName.BLOQUEIO_DE_ACESSO,
      subReasonByName.MATERIAL_INFORMATIVO,
      subReasonByName.QV_ACOES_DE_SAUDE,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE, AttendanceReasonVisibilityGroup.FEE_FOR_LIFE],
    'label': 'Portal do RH',
    'value': 'Portal do RH',
    'subReasons': [
      subReasonByName.ATUALIZACAO_DE_INFORMACOES,
      subReasonByName.AUXILIO_NO_LOGIN,
      subReasonByName.CRIACAO_DE_USUARIO,
      subReasonByName.DESBLOQUEIO_DE_USUARIO,
      subReasonByName.DUVIDAS,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Rede credenciada',
    'value': 'Rede credenciada',
    'subReasons': [
      subReasonByName.DUVIDA_DESCREDENCIAMENTO,
      subReasonByName.INDICACAO_DE_CREDENCIAMENTO,
      subReasonByName.REDE_CREDENCIADA,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Reembolso',
    'value': 'Reembolso',
    'subReasons': [
      subReasonByName.INFORMACOES_DE_REEMBOLSO,
      subReasonByName.PREVIA_DE_REEMBOLSO,
      subReasonByName.REEMBOLSO_REANALISE,
      subReasonByName.SOLICITAR_REEMBOLSO,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Relatórios Gerenciais',
    'value': 'Relatórios Gerenciais',
    'subReasons': [
      subReasonByName.COMITE_DE_SAUDE,
      subReasonByName.COMITE_OPERACIONAL,
      subReasonByName.DUVIDA,
      subReasonByName.RELATORIOS_GERENCIAIS,
    ],
  },
  {
    'visibilityGroup': [AttendanceReasonVisibilityGroup.FEE_FOR_SERVICE],
    'label': 'Seguro de Vida',
    'value': 'Seguro de Vida',
    'subReasons': [
      subReasonByName.DOCUMENTACAO,
      subReasonByName.ENVIO_CERTIFICADO_SEGURO_VIDA,
      subReasonByName.IMPORTACAO_BASE_SEGURO_VIDA,
      subReasonByName.INFORMACOES,
    ],
  },
];
